import { WeatherIconComponent } from '../Icon/WheaterIconComponent';
import type { WeatherReport } from '../api/internal-api-types';

import { ForecastSection } from './ForecastSection';
import { WeatherValue } from './WeatherValue';
import styles from './WeekForecast.module.scss';

type Props = {
	forecast: WeatherReport['days'];
	selectedDate: string | null;
	onChangeSelectedDate?: (date: string) => void;
	className?: string;
};

export function WeekForecast({ forecast, className, selectedDate, onChangeSelectedDate }: Props) {
	return (
		<ForecastSection title="Wochenvorhersage" className={className}>
			{forecast.map(({ date, maxTemp, minTemp, icon }, index) => {
				const selected = selectedDate ? selectedDate === date.timestamp : index === 0;

				return (
					<button
						className={`${styles.dayForecast} ${selected ? styles.selected : ''} heading3 button-link outline-inside no-focus no-hover`}
						key={date.timestamp}
						onClick={() => {
							onChangeSelectedDate?.(date.timestamp);
						}}
					>
						<time className={`heading4 ${styles.date}`} dateTime={date.timestamp}>
							{date.humanReadable}
						</time>
						{icon ? <WeatherIconComponent name={icon} className={styles.icon} /> : null}
						<div className={styles.temperature}>
							<span>
								<WeatherValue {...maxTemp} separator="" />
							</span>
							<span>
								<WeatherValue {...minTemp} separator="" />
							</span>
						</div>
					</button>
				);
			})}
		</ForecastSection>
	);
}
